export default __webpack_public_path__ + "static/media/executiveChairman.8f65f7b4.svg";